export default {
  locale: 'zh-cn',
  TableFilter: {
    resultLabel: '筛选结果',
    expanse: '展开筛选',
    collapse: '收起筛选',
    clear: '清空筛选',
    emptyField: '无查询项',
    total: '共',
    totalInfo: '条记录',
    advanceSearch: '高级搜索'
  },
  Tag: {
    verifiedInvoice: '发票已验',
    freeInvoice: '免票',
    childFee: '子'
  },
  HelpComponent: {
    more: 'More'
  },
  Popedit: {
    none: '未选择',
    placeholder: '请选择'
  }
};
//# sourceMappingURL=default.js.map
